import { Component, Input, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { TimeSetupService } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-homeroom-grid",
	templateUrl: "./homeroom-grid.component.html",
	styleUrls: ["./homeroom-grid.component.css"],
})
export class HomeroomGridComponent implements OnInit {
	constructor(private timeSetupService: TimeSetupService, private confirmationService: ConfirmationService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		if (this.SchoolID != undefined) {
			this.loadHomeroomList();
		}
	}

	ngOnChanges() {
		if (this.SchoolID != undefined) {
			this.loadHomeroomList();
		}
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SchoolID: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedHomeroom: any;
	lstHomeroom: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "Homeroom", header: "Homeroom" },
		// { field: 'TardyTime', header: 'Tardy Time' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadHomeroomList() {
		this.loading = true;

		var result = this.timeSetupService.TimeSettingsHomeroomSelectList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstHomeroom = response;

				var TodayStr: String = moment(new Date()).format("MM/DD/YYYY");

				for (var i = 0; i < this.lstHomeroom.length; i++) {
					var next = this.lstHomeroom[i];

					//Create Date from Tardy Time string
					if (next.TardyTime != "") {
						next.TardyTimeDate = new Date(String(next.TardyTime));
					} else {
						var Today = new Date();
						Today.setHours(0, 0, 0, 0);
						next.TardyTimeDate = Today;
					}
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////
	onUpdate(val) {
		var fTime = "1900-01-01 " + moment(new Date(val.TardyTimeDate)).format("HH:mm:00");

		var result = this.timeSetupService.TimeSettingsUpdateHomeroomTardyTime(val.HomeroomID, fTime);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "timehomeroom",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Homeroom Tardy Time was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadHomeroomList();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "timehomeroom",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Homeroom's Tardy Time",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onReset(val) {
		//There should only be 1 school for a given school ID
		var next = val;

		var TodayStr: String = moment(new Date()).format("MM/DD/YYYY");

		if (next.TardyTime != "") {
			next.TardyTimeDate = new Date(String(next.TardyTime));
		} else {
			var Today = new Date();
			Today.setHours(0, 0, 0, 0);
			next.TardyTimeDate = Today;
		}
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedHomeroom = val.data;
	}
	onRowUnselect(val) {
		this.SelectedHomeroom = null;
	}

	////////////////////////////////////////////
}
